import { MARKETPLACE_FEATURE } from '@/config/marketplaceCapabilities.js';
import { isSellerFeedbackEnabled } from '@/config/sellerFeedback.js';

export default [
  {
    title: 'Business Reports',
    channel: 'amazon-seller',
    icon: { icon: 'ic:outline-assessment' },
    //envOnly: 'development',
    feature: MARKETPLACE_FEATURE.BUSINESS_REPORTS,
    children: [
      
      {
        title: 'Sales & Traffic by ASIN',
        action: 'read',
        subject: 'User',
        to: 'business-reports-sales-traffic-by-asin-dk',
        icon: { icon: 'ic:outline-insights' },
        //envOnly: 'development',
      },
      {
        title: 'Sales & Traffic by SKU',
        action: 'read',
        subject: 'User',
        to: 'business-reports-sales-traffic-by-sku-dk',
        icon: { icon: 'ic:outline-insights' },
        envOnly: 'development',
      },
      {
        title: 'Economics / P&L',
        action: 'read',
        subject: 'User',
        to: 'finance-economics',
        icon: { icon: 'ic:outline-account-tree' },
        //envOnly: 'development',
      },
      // Gated by VITE_ENABLE_SELLER_FEEDBACK and dev-only again (owner, 2026-10-14; route in devOnlyPaths).
      ...(isSellerFeedbackEnabled()
        ? [
          {
            title: 'Seller Feedback',
            action: 'read',
            subject: 'User',
            to: { name: 'business-reports-seller-feedback-tab', params: { tab: 'feedback' } },
            icon: { icon: 'ic:outline-rate-review' },
            envOnly: 'development',
          },
        ]
        : []),
      {
        title: 'Promotions',
        action: 'read',
        subject: 'User',
        to: { name: 'business-reports-promotions-tab', params: { tab: 'promotions' } },
        icon: { icon: 'ic:outline-local-offer' },
        envOnly: 'development',
      },
      // {
      //   title: 'Customer Shipment Sales',
      //   badgeContent: 'B',
      //   badgeClass: 'bg-primary',
      //   action: 'read',
      //   subject: 'User',
      //   to: 'business-reports-sales-shipment-revenue',
      //   icon: { icon: 'ic:outline-monetization-on' },
      //   envOnly: 'development',
      // },
      // {
      //   title: 'Sales & Traffic by ASIN',
      //   badgeContent: 'RP-B',
      //   badgeClass: 'bg-primary',
      //   action: 'read',
      //   subject: 'User',
      //   to: 'business-reports-sales-traffic-by-asin',
      //   icon: { icon: 'ic:outline-trending-up' },
      //   envOnly: 'development',
      // },
    ],
  },
];
